// extracted by mini-css-extract-plugin
export default {"timer":"style_timer__70uxo","timer__text":"style_timer__text__l3cPV"};